import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice'
import locationReducer from './locationSlice'
import wishlistReducer, { selectWishlistItems } from './wishlistSlice'
import cartReducer from './cartSlice'
import { api } from './api'
import { saveWishlist } from '../utils/wishlistStorage'

// The RTK Query `api` slice is wired in here (reducer + middleware). Endpoints are added
// incrementally in store/api.js. Existing hand-rolled fetch calls keep working;
// migrations are bisectable.
export const store = configureStore({
    reducer: {
        user: userReducer,
        location: locationReducer,
        wishlist: wishlistReducer,
        cart: cartReducer,
        [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(api.middleware),
})

// Persist wishlist to localStorage on any state change. This replaces the per-reducer
// `saveWishlist()` calls that lived inside every wishlist reducer/case — now there's
// exactly one write path, so future reducers don't have to remember to wire up
// persistence individually. Cheap: only triggers a string compare + localStorage write
// when the items array actually changes reference.
let lastPersistedWishlist = selectWishlistItems(store.getState())
store.subscribe(() => {
    const items = selectWishlistItems(store.getState())
    if (items !== lastPersistedWishlist) {
        lastPersistedWishlist = items
        try { saveWishlist(items) } catch {}
    }
})
